import { useTranslation } from 'react-i18next';

export function PastTransactionsPage() {
  const { t } = useTranslation('members');
  return (
    <section>
      <h2 className="text-base font-semibold">{t('payments.pages.pastTransactions.sectionTitle')}</h2>
      <p className="text-sm text-muted-foreground mt-1">{t('payments.pages.pastTransactions.sectionDescription')}</p>
    </section>
  );
}
